import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { UrlsService } from "./core/services/urls.service";
import { HttpService } from "./core/services/http.service";
import { ChatService } from "./core/services/chat.service";
import { SharedService } from "./core/services/shared-service/shared.service";
import { UserRoleService } from "./core/services/user-role.service";
import { CommonUtilService } from "./core/services/common-util-service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient, private userRoleService: UserRoleService, private commonUtilService: CommonUtilService, private httpService: HttpService, private sharedService: SharedService, private webSocketService: ChatService, private urlService: UrlsService) {}

  getAccessToken(): string | null {
    return sessionStorage.getItem("token");
  }

  getRefreshToken(): string | null {
    return localStorage.getItem("refreshToken");
  }

  setTokens(access: string, refresh?: string) {
    sessionStorage.setItem("token", access);
    if (refresh) {
      localStorage.setItem("refreshToken", refresh);
    }
  }

  logout() {
    // this.doOffline();
    this.setuserFiltersLogout();
    this.httpService.callApi("logout", {}).subscribe(
      (response) => {
        sessionStorage.clear();
        localStorage.clear();
        this.webSocketService.disconnect();
        this.sharedService.kanbanOffSet = undefined;
        this.sharedService.kanbanData = undefined;
        this.sharedService.setkanbanDoneData(undefined);
        this.sharedService.kanbanDoneOffSet = 0;
        this.sharedService.setkanbanTODoData(undefined);
        this.sharedService.kanbanToDoOffSet = 0;
        this.sharedService.setProjectInfo([]);
        this.sharedService.multipleCallRemover([], "personalList");
        this.sharedService.multipleCallRemover([], "equipmentList");
        let blankArr = [];
        this.sharedService.setAllKitListByLoggedInUser(blankArr);
        this.userRoleService.clear();
        this.httpService.logout();
        this.userRoleService.logout();
      },
      (error) => {
        localStorage.clear();
        sessionStorage.clear();

        this.userRoleService.clear();
      }
    );
  }

  async setuserFiltersLogout() {
    try {
      let userid = localStorage.getItem("userId");
      let filterData: any = this.sharedService.getuserFilters();
      if (filterData.staffMemberId != undefined && filterData.staffMemberId != null) {
        if (filterData.values != null) {
          for (const property in filterData.values) {
            for (let i = 0; i < filterData.values[property].length; i++) {
              if (filterData.values[property][i].filterId != undefined) {
                delete filterData.values[property][i].filterId;
              }
              if (filterData.values[property][i].id != undefined) {
                delete filterData.values[property][i].id;
              }
              //  return
              if (filterData.values[property][i].recordKey == "pendingBooking") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "dateRangeFeild") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "projectTheme") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "tableTimeFlag") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "timeFormatUser") {
                continue;
              }

              if (filterData.values[property][i].recordKey == "dateFormatUser") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "PersistantRange") {
                continue;
              }
              if (filterData.values[property][i].mapId == "CUSTOMBORAD") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "schedulerTimeZone") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "schedulerLabel") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "statusTheme") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "extendedContent") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "moveEvent") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "resizeEvent") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "weekendContent") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "buissnessHour") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "rosterContent") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedKitId") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "board") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "list") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "kanban") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "router") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "routerClient") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "routerEquipment") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "routerPersonal") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "routerSideNav") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "caledarView") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "caledarViewScheduleProject") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "routerPkanban") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "projectCard") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "dSubclient") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "dDate") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "dTheme") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "dProjectOwner") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "dLocation") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "dBuissnessUnit") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "LISTFILTERARR") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "displayView") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "showChartR") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "lastDateRange") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "reportView") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedPeriod") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedTimeframe") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedYearOption") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedMonth") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "isPeriodOrTimeframeChanged") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "isYearOrMonthChanged") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "orderForms") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "headerDview") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "showTx") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedPeriodBoard") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedTimeframeBoard") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedYearOptionBoard") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "selectedMonthBoard") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "isPeriodOrTimeframeChangedBoard") {
                continue;
              }
              if (filterData.values[property][i].recordKey == "isYearOrMonthChangedBoard") {
                continue;
              }

              filterData.values[property][i].recordValue = "";
            }
          }
        }
      }

      if (filterData?.staffMemberId == null) {
        filterData.staffMemberId = userid;
      }

      const res: any = await this.commonUtilService.setfilters(filterData);
    } catch (error) {
      console.log(error);
    }
  }

  refresh(): Observable<any> {
    const refreshToken = this.getRefreshToken();
    return this.http.post(`${this.urlService.urlString}auth/refresh`, { refreshToken }).pipe(
      tap((res: any) => {
        // Update both tokens if returned
        this.setTokens(res.accessToken, res.refreshToken);
      })
    );
  }
}
